// extracted by mini-css-extract-plugin
export var agreementPage = "index-module--agreementPage--nZTIL";
export var contentHeader = "index-module--contentHeader--qayzS";
export var contentMain = "index-module--contentMain--Q8hty";
export var date = "index-module--date--WUfOA";
export var mainItem = "index-module--mainItem--oWXt6";
export var mainTitle = "index-module--mainTitle--SCmjE";
export var pannel = "index-module--pannel--JG228";
export var phoneShowBox = "index-module--phoneShowBox--Y+72R";